import React from 'react';
import { Procedure } from 'types/procedure';
import ProcedureItemModule from './ProcedureItemModule';
import List from 'components/list/List';

type ProcedureListModuleProps = {
  procedures: Procedure[];
};

const ProcedureListModule: React.FC<ProcedureListModuleProps> = ({ procedures }) => {
  return (
    <List>
      {procedures.map(procedure => (
        <ProcedureItemModule key={procedure.id} procedure={procedure} />
      ))}
    </List>
  );
};

export default ProcedureListModule;
